<template>
  <div>
    <!-- 预约咨询 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      @close="close"
    >
      <el-form
        :model="agriculturalFeedbackForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="姓名" prop="userName">
          <el-input
            v-model="agriculturalFeedbackForm.userName"
            placeholder="请输入您的姓名或称呼"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input
            v-model="agriculturalFeedbackForm.contact"
            placeholder="请输入您的联系方式"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="content">
          <el-input
            v-model="agriculturalFeedbackForm.content"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    data: Boolean
  },
  data() {
    return {
      dialogVisible: this.data,
      rules: {
        userName: [
          { required: true, message: '请输入您的姓名或称呼', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请输入您的联系方式', trigger: 'change' }
        ]
      },
      agriculturalFeedbackForm: {
        userName: '',
        contact: '',
        content: '', // 备注
        source: 2 // 反馈来源 0-消费者C端 2-官网智慧农贸 3-官网 AI识别
      },
      title: '预约咨询'
    }
  },
  watch: {
    data: {
      immediate: true,
      handler: function(value) {
        this.dialogVisible = value
      }
    }
  },
  created() {
    console.log(this.data)
  },
  methods: {
    close() {
      this.dialogVisible = false
      this.$emit('refer', false)
      // 清空列表
      this.agriculturalFeedbackForm.userName = ''
      this.agriculturalFeedbackForm.content = ''
      this.agriculturalFeedbackForm.contact = ''
    },
    // 提交申请
    async submit() {
      // 验证表单是否合理
      this.$refs.ruleForm.validate(async valid => {
        if (!valid) return
        // 验证通过，进行下一步操作
        const { data: res } = await this.$http.post(
          '/api/v1/user/agriculturalFeedback',
          this.agriculturalFeedbackForm
        )
        // console.log(response)
        if (res.code !== 0) {
          return this.$message.error(res.message)
        }
        this.$message.success('预约成功')
        this.dialogVisible = false
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
